/* ============================================================
   OLIO MADÒ — Theme JavaScript
   Dark Luxury Edition — Oil Drop · 3D Cards · Elegant Fall
   ============================================================ */

/* Rispetta prefers-reduced-motion anche per le animazioni JS (Lenis/GSAP/rAF),
   non solo per quelle CSS: il media query CSS non ferma Lenis/GSAP/requestAnimationFrame. */
var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.addEventListener('DOMContentLoaded', () => {
  initSmoothScroll();
  initCursor();
  initHeader();
  initRevealAnimations();
  initOilDrop();
  initCard3D();
  initHeroParallax();
  initCounters();
  initValueTree();
  initProductGallery();
  initCartDrawer();
  initSearchModal();
  initMobileNav();
  initPageTransition();
  initMagneticButtons();
  initVariantPicker();
  // Free shipping bar: init con totale server-side
  const _shipBar = document.getElementById('cart-ship-bar');
  if (_shipBar) updateShipBar(parseInt(_shipBar.dataset.current, 10) || 0);
  initRecentlyViewed();
});

/* ────────────────────────────────────────────────────────────
   SMOOTH SCROLL (Lenis)
──────────────────────────────────────────────────────────── */
let lenis;
function initSmoothScroll() {
  if (document.body.dataset.smoothScroll === 'false') return;
  if (typeof Lenis === 'undefined') return;
  if (prefersReducedMotion) return;

  const _dur = parseFloat(document.body.dataset.scrollDuration || '14') / 10;
  lenis = new Lenis({
    duration: _dur,
    easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smooth: true,
    smoothTouch: false,
  });

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(time => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(0);
  }

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  if (typeof gsap === 'undefined') requestAnimationFrame(raf);

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', e => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) { e.preventDefault(); lenis.scrollTo(target, { offset: -80 }); }
    });
  });
}

/* ────────────────────────────────────────────────────────────
   CUSTOM CURSOR
──────────────────────────────────────────────────────────── */
function initCursor() {
  if (document.body.dataset.cursor === 'false') return;
  const cursor = document.getElementById('cursor');
  if (!cursor || window.matchMedia('(hover: none)').matches || prefersReducedMotion) return;

  const dot  = cursor.querySelector('.cursor__dot');
  const ring = cursor.querySelector('.cursor__ring');
  let mouseX = -100, mouseY = -100;
  let ringX  = -100, ringY  = -100;

  document.addEventListener('mousemove', e => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    dot.style.transform = `translate(${mouseX}px, ${mouseY}px) translate(-50%, -50%)`;
  });

  function animateRing() {
    ringX += (mouseX - ringX) * 0.12;
    ringY += (mouseY - ringY) * 0.12;
    ring.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%, -50%)`;
    requestAnimationFrame(animateRing);
  }
  animateRing();

  document.querySelectorAll('a, button, [data-cursor-hover]').forEach(el => {
    el.addEventListener('mouseenter', () => document.body.classList.add('cursor--hover'));
    el.addEventListener('mouseleave', () => document.body.classList.remove('cursor--hover'));
  });
}

/* ────────────────────────────────────────────────────────────
   HEADER — scroll show/hide
──────────────────────────────────────────────────────────── */
function initHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  let lastScroll = 0;
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const cur = window.scrollY;
        header.classList.toggle('is-scrolled', cur > 20);
        lastScroll = cur;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  document.querySelectorAll('.site-nav__link').forEach(link => {
    if (link.href === window.location.href) link.classList.add('is-active');
  });
}

/* ────────────────────────────────────────────────────────────
   REVEAL ANIMATIONS (Intersection Observer)
──────────────────────────────────────────────────────────── */
function initRevealAnimations() {
  document.body.classList.add('js-animate');
  const els = document.querySelectorAll('.reveal');
  if (!els.length) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  els.forEach(el => observer.observe(el));
}

/* ────────────────────────────────────────────────────────────
   OIL DROP SCROLL INDICATOR
   Fixed on the left — fills gold as page scrolls — falls at end
   SVG created via JS to avoid Liquid/SVG parser conflicts
──────────────────────────────────────────────────────────── */
function initOilDrop() {
  if (document.body.dataset.oilDrop === 'false') return;
  const indicator = document.getElementById('oil-drop-indicator');
  if (!indicator) return;
  if (prefersReducedMotion) { indicator.style.display = 'none'; return; }

  const ORGANIC_PATH = 'M 22 4 C 15 16 3 30 4 44 C 4.5 55 11 62 22 62 C 33 62 39.5 55 40 44 C 41 30 29 16 22 4 Z';

  // Pure SVG — no canvas, no explosion
  indicator.innerHTML = [
    '<svg id="oil-drop-svg" viewBox="0 0 44 66" xmlns="http://www.w3.org/2000/svg" overflow="visible">',
    '  <defs>',
    '    <clipPath id="drop-shape-clip"><path d="' + ORGANIC_PATH + '"/></clipPath>',
    '    <linearGradient id="goldGrad" x1="0" y1="0" x2="0" y2="1">',
    '      <stop offset="0%" stop-color="#E6C86A"/><stop offset="100%" stop-color="#9A7020"/>',
    '    </linearGradient>',
    '    <filter id="oil-glow" x="-40%" y="-40%" width="180%" height="180%">',
    '      <feGaussianBlur stdDeviation="3" result="blur"/>',
    '      <feComposite in="SourceGraphic" in2="blur" operator="over"/>',
    '    </filter>',
    '  </defs>',
    '  <path class="drop-outline" d="' + ORGANIC_PATH + '"/>',
    '  <path id="oil-wave-path" class="drop-wave" clip-path="url(#drop-shape-clip)" filter="url(#oil-glow)"/>',
    '  <ellipse class="drop-shine" cx="14" cy="28" rx="4" ry="7" transform="rotate(-18,14,28)" clip-path="url(#drop-shape-clip)"/>',
    '  <ellipse class="drop-shine--sm" cx="19" cy="16" rx="2" ry="3.5" transform="rotate(-12,19,16)" clip-path="url(#drop-shape-clip)"/>',
    '</svg>',
  ].join('\n');

  const wavePath = document.getElementById('oil-wave-path');
  if (!wavePath) return;

  let currentFillY = 62;
  let hasLanded    = false;
  let isFalling    = false;
  const DROP_TOP    = 4;
  const DROP_BOTTOM = 62;
  const DROP_RANGE  = DROP_BOTTOM - DROP_TOP;

  // ── Wave animation ────────────────────────────────────────────
  let waveStart = null;
  function animateWave(ts) {
    if (!waveStart) waveStart = ts;
    const t  = (ts - waveStart) / 1000;
    const y  = currentFillY;
    const a1 = Math.sin(t * 1.4)       * 1.8;
    const a2 = Math.cos(t * 0.9)       * 1.5;
    const a3 = Math.sin(t * 2.0 + 0.8) * 0.9;
    const wd = [
      'M 0 ' + (y + a2).toFixed(2),
      'C 10 ' + (y + a1).toFixed(2) + ' 18 ' + (y - a2 * 0.7).toFixed(2) + ' 22 ' + (y + a3).toFixed(2),
      'C 28 ' + (y - a1 * 0.5).toFixed(2) + ' 36 ' + (y + a2 * 0.6).toFixed(2) + ' 44 ' + (y + a3 * 0.4).toFixed(2),
      'L 44 70 L 0 70 Z',
    ].join(' ');
    wavePath.setAttribute('d', wd);
    requestAnimationFrame(animateWave);
  }
  requestAnimationFrame(animateWave);

  // ── Fall sequence ─────────────────────────────────────────────
  // The CSS gives the indicator transform:translateY(-50%) for vertical centering.
  // We preserve this when applying fall transforms.
  const BASE_TRANSFORM = 'translateY(-50%)';
  // FALL_PX rimosso — distanza calcolata dinamicamente in beginFall()

  function startFall() {
    isFalling = true;
    const dropSvg = document.getElementById('oil-drop-svg');

    function beginFall() {
      // ── Calcola distanza e durata della caduta ────────────────
      // fallDistance: spazio tra il fondo dell'indicatore e il fondo del viewport
      var rect         = indicator.getBoundingClientRect();
      var fallDistance = Math.max(60, window.innerHeight - rect.bottom - 8);
      // fallDuration: scala con la distanza (effetto gravitazionale), max 1000ms
      var fallDuration = Math.round(Math.min(1000, 600 + fallDistance * 0.8));

      // ── A) Elongate drop: simulates aerodynamic deformation ──
      if (dropSvg) {
        dropSvg.style.transformOrigin = 'center center';
        dropSvg.style.transition      =
          'transform ' + Math.round(fallDuration * 0.95) + 'ms cubic-bezier(0.22, 0.1, 0.72, 1.0),' +
          ' filter 0.25s ease';
        dropSvg.style.transform = 'scaleX(0.78) scaleY(1.30)';
        // Golden speed-trail glow during fall
        dropSvg.style.filter =
          'drop-shadow(0 10px 20px rgba(200,160,60,0.90)) ' +
          'drop-shadow(0 -2px 6px rgba(200,160,60,0.35))';
      }

      // ── B) Free fall — physics easing (slow start → acceleration) ──
      indicator.style.transition = 'transform ' + fallDuration + 'ms cubic-bezier(0.36, 0, 0.55, 1.0)';
      indicator.style.transform  = BASE_TRANSFORM + ' translateY(' + fallDistance + 'px)';

      // ── C) Landing: squish flat, then fade ──
      setTimeout(function () {
        // Impact squish
        if (dropSvg) {
          dropSvg.style.transition = 'transform 0.10s cubic-bezier(0.4, 0, 1, 1), filter 0.10s ease';
          dropSvg.style.transform  = 'scaleX(2.2) scaleY(0.20)';
          dropSvg.style.filter     = 'drop-shadow(0 0 26px rgba(200,160,60,1.0))';
        }

        // Landing glow: small elliptical shimmer at impact point
        var rect = indicator.getBoundingClientRect();
        var glowEl = document.createElement('div');
        glowEl.style.cssText =
          'position:fixed;' +
          'left:' + (rect.left + rect.width  / 2) + 'px;' +
          'top:'  + (rect.top  + rect.height * 0.85) + 'px;' +
          'width:72px;height:22px;' +
          'transform:translate(-50%,-50%);' +
          'background:radial-gradient(ellipse at center,' +
            'rgba(200,160,60,0.80) 0%,rgba(200,160,60,0) 72%);' +
          'border-radius:50%;pointer-events:none;z-index:9999;' +
          'opacity:0;transition:opacity 0.10s ease-in;';
        document.body.appendChild(glowEl);
        requestAnimationFrame(function () { glowEl.style.opacity = '1'; });
        setTimeout(function () {
          glowEl.style.transition = 'opacity 0.60s ease-out';
          glowEl.style.opacity    = '0';
          setTimeout(function () { glowEl.remove(); }, 700);
        }, 200);

        // Fade out the indicator
        setTimeout(function () {
          indicator.style.transition = 'opacity 0.55s ease-out';
          indicator.style.opacity    = '0';
          hasLanded = true;
        }, 110);

      }, fallDuration);
    }

    if (dropSvg) {
      // Pre-fall wobble: left → right → fall (builds anticipation)
      dropSvg.style.transformOrigin = 'center bottom';
      dropSvg.style.transition      = 'transform 0.18s ease-in-out';
      dropSvg.style.transform       = 'rotate(-8deg) scale(1.07)';
      setTimeout(function () {
        dropSvg.style.transition = 'transform 0.15s ease-in-out';
        dropSvg.style.transform  = 'rotate(6deg) scale(1.04)';
      }, 180);
      setTimeout(function () {
        dropSvg.style.transition = 'none';
        dropSvg.style.transform  = 'none';
        beginFall();
      }, 330);
    } else {
      beginFall();
    }
  }

  // ── Revive after scroll-back ───────────────────────────────────
  function reviveIndicator() {
    hasLanded = false;
    isFalling = false;
    const dropSvg = document.getElementById('oil-drop-svg');
    // Teleport back to centered position instantly — keep the -50% centering
    indicator.style.transition = 'none';
    indicator.style.transform  = BASE_TRANSFORM;
    indicator.style.opacity    = '0';
    if (dropSvg) {
      dropSvg.style.transition = 'none';
      dropSvg.style.transform  = 'none';
      dropSvg.style.opacity    = '1';
      dropSvg.style.filter     = '';
    }
    // Force reflow before fade-in
    void indicator.offsetWidth;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        indicator.style.transition = 'opacity 0.8s ease, transform 0.4s ease';
        indicator.style.opacity    = '1';
      });
    });
  }

  function updateDrop() {
    const scrollY   = window.scrollY;
    const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    // Don't run on pages too short to scroll meaningfully
    if (maxScroll < 250) return;
    const progress  = Math.min(scrollY / maxScroll, 1);

    currentFillY = DROP_BOTTOM - DROP_RANGE * progress;

    // Progressive glow while filling
    if (!isFalling && !hasLanded) {
      const glow      = 8 + progress * 18;
      const glowAlpha = 0.3 + progress * 0.7;
      const dropSvg   = document.getElementById('oil-drop-svg');
      if (dropSvg) {
        dropSvg.style.filter =
          'drop-shadow(0 0 ' + glow + 'px rgba(200,160,60,' + glowAlpha + '))';
      }
    }

    // Trigger fall at 75% scroll, or when near page bottom (min 15% progress guard)
    const nearBottom =
      (document.documentElement.scrollHeight - (scrollY + window.innerHeight)) < 220 &&
      progress > 0.15;
    if ((progress >= 0.75 || nearBottom) && !isFalling && !hasLanded) {
      startFall();
    }

    // Revive when scrolled back above 70%
    if (progress < 0.70 && hasLanded) {
      reviveIndicator();
    }
  }

  // Graceful fade-in on first load
  indicator.style.opacity = '0';
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      indicator.style.transition = 'opacity 1.2s ease';
      indicator.style.opacity    = '1';
    });
  });

  window.addEventListener('scroll', updateDrop, { passive: true });
  updateDrop();
}

/* ────────────────────────────────────────────────────────────
   3D CARD TILT (Product Cards)
──────────────────────────────────────────────────────────── */
function initCard3D() {
  if (document.body.dataset.card3d === 'false') return;
  // Only on non-touch devices
  if (window.matchMedia('(hover: none)').matches || prefersReducedMotion) return;

  function applyTilt(cards) {
    cards.forEach(card => {
      // Add shine overlay if not present
      if (!card.querySelector('.card-shine')) {
        const shine = document.createElement('div');
        shine.className = 'card-shine';
        card.appendChild(shine);
      }
      const shine = card.querySelector('.card-shine');

      card.addEventListener('mousemove', e => {
        const rect = card.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width  - 0.5;  // -0.5 to +0.5
        const y = (e.clientY - rect.top)  / rect.height - 0.5;  // -0.5 to +0.5

        const maxRot = 4;
        const rotX   = -y * maxRot;
        const rotY   =  x * maxRot;

        card.style.transform    = `perspective(1000px) rotateX(${rotX}deg) rotateY(${rotY}deg) scale(1.03)`;
        card.style.transition   = 'transform 0.08s ease-out, box-shadow 0.08s ease-out';
        card.style.boxShadow    = `
          0 ${20 + y * 20}px ${60 + Math.abs(y) * 20}px rgba(0,0,0,0.5),
          0 0 40px rgba(200,160,60,${0.1 + Math.abs(x) * 0.15})
        `;
        shine.style.background  = `radial-gradient(
          circle at ${(x + 0.5) * 100}% ${(y + 0.5) * 100}%,
          rgba(200,160,60,0.18) 0%,
          rgba(255,255,255,0.04) 40%,
          transparent 70%
        )`;
      });

      card.addEventListener('mouseleave', () => {
        card.style.transform  = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)';
        card.style.transition = 'transform 0.6s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.6s ease';
        card.style.boxShadow  = '';
        shine.style.background = 'transparent';
      });

      // Click ripple
      card.addEventListener('mousedown', e => {
        const rect = card.getBoundingClientRect();
        const ripple = document.createElement('div');
        ripple.style.cssText = `
          position:absolute;
          border-radius:50%;
          background:rgba(200,160,60,0.15);
          width:4px;height:4px;
          left:${e.clientX - rect.left}px;
          top:${e.clientY - rect.top}px;
          transform:translate(-50%,-50%) scale(0);
          transition:transform 0.6s ease,opacity 0.6s ease;
          pointer-events:none;
          z-index:10;
        `;
        card.appendChild(ripple);
        requestAnimationFrame(() => {
          ripple.style.transform = 'translate(-50%,-50%) scale(100)';
          ripple.style.opacity   = '0';
        });
        setTimeout(() => ripple.remove(), 700);
      });
    });
  }

  // Initial cards
  applyTilt(document.querySelectorAll('.product-card'));

  // Watch for dynamically added cards
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.classList?.contains('product-card')) applyTilt([node]);
          node.querySelectorAll?.('.product-card').forEach(c => applyTilt([c]));
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

/* ────────────────────────────────────────────────────────────
   MAGNETIC BUTTONS
──────────────────────────────────────────────────────────── */
function initMagneticButtons() {
  if (window.matchMedia('(hover: none)').matches || prefersReducedMotion) return;

  document.querySelectorAll('.btn--gold, .btn--primary').forEach(btn => {
    btn.addEventListener('mousemove', e => {
      const rect = btn.getBoundingClientRect();
      const x    = (e.clientX - rect.left - rect.width  / 2) * 0.25;
      const y    = (e.clientY - rect.top  - rect.height / 2) * 0.25;
      btn.style.transform    = `translate(${x}px, ${y}px)`;
      btn.style.transition   = 'transform 0.2s ease';
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.transform  = '';
      btn.style.transition = 'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
    });
  });
}

/* ────────────────────────────────────────────────────────────
   HERO PARALLAX
──────────────────────────────────────────────────────────── */
function initHeroParallax() {
  if (prefersReducedMotion) return;
  const heroMedia = document.querySelector('.hero__media img, .hero__media video');
  if (heroMedia) {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.to(heroMedia, {
        yPercent: 25,
        ease: 'none',
        scrollTrigger: {
          trigger: '.hero',
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        }
      });
    } else {
      window.addEventListener('scroll', () => {
        heroMedia.style.transform = `translateY(${window.scrollY * 0.25}px)`;
      }, { passive: true });
    }
  }

  const sphere = document.querySelector('.hero__sphere');
  if (sphere) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      sphere.style.transform = `translateY(${y * 0.15}px)`;
    }, { passive: true });
  }

  const quoteBg = document.querySelector('.parallax-quote__bg');
  if (quoteBg && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.to(quoteBg, {
      yPercent: -15,
      ease: 'none',
      scrollTrigger: {
        trigger: '.parallax-quote',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      }
    });
  }

  const storySplitImg = document.querySelector('.story-split__img');
  if (storySplitImg && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.fromTo(storySplitImg,
      { yPercent: -8 },
      {
        yPercent: 8,
        ease: 'none',
        scrollTrigger: {
          trigger: '.story-split',
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        }
      }
    );
  }
}

/* ────────────────────────────────────────────────────────────
   ANIMATED COUNTERS
──────────────────────────────────────────────────────────── */
function initCounters() {
  const counters = document.querySelectorAll('[data-counter]');
  if (!counters.length) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el       = entry.target;
      const target   = parseFloat(el.dataset.counter);
      const prefix   = el.dataset.prefix || '';
      const suffix   = el.dataset.suffix || '';
      const decimals = el.dataset.decimals ? parseInt(el.dataset.decimals) : 0;
      if (prefersReducedMotion) { el.textContent = prefix + target.toFixed(decimals) + suffix; observer.unobserve(el); return; }
      const duration = 2200;
      const start    = performance.now();

      function update(now) {
        const elapsed  = now - start;
        const progress = Math.min(elapsed / duration, 1);
        const eased    = 1 - Math.pow(1 - progress, 4);
        el.textContent = prefix + (eased * target).toFixed(decimals) + suffix;
        if (progress < 1) requestAnimationFrame(update);
      }
      requestAnimationFrame(update);
      observer.unobserve(el);
    });
  }, { threshold: 0.5 });

  counters.forEach(c => observer.observe(c));
}

/* ────────────────────────────────────────────────────────────
   OLIVE TREE — cresce quando la sezione Valori entra in vista
──────────────────────────────────────────────────────────── */
function initValueTree() {
  const tree = document.querySelector('.values-counter__tree');
  if (!tree) return;
  if (prefersReducedMotion) { tree.classList.add('is-grown'); return; } // visibile, niente animazione
  tree.classList.add('vc-anim');
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { tree.classList.add('is-grown'); io.unobserve(tree); }
    });
  }, { threshold: 0.3 });
  io.observe(tree);
}

/* ────────────────────────────────────────────────────────────
   PRODUCT GALLERY
──────────────────────────────────────────────────────────── */
function initProductGallery() {
  const gallery  = document.querySelector('.product-gallery');
  if (!gallery) return;

  const mainSlot = gallery.querySelector('.product-gallery__main');
  const thumbs   = gallery.querySelectorAll('.product-gallery__thumb');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mediaType = thumb.dataset.mediaType || 'image';

      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');

      if (mediaType === 'video') {
        /* ── Video Shopify hosted ── */
        const videoSrc = thumb.dataset.videoSrc;
        if (!videoSrc) return;
        const existing = mainSlot.querySelector('img, video, iframe');
        const video = document.createElement('video');
        video.id = 'product-main-video';
        video.src = videoSrc;
        video.controls = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.autoplay = true;
        video.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;';
        if (existing) existing.replaceWith(video);
        else mainSlot.appendChild(video);

      } else if (mediaType === 'external_video') {
        /* ── Video YouTube / Vimeo ── */
        const extId  = thumb.dataset.externalId;
        const host   = thumb.dataset.externalHost;
        const src = host === 'youtube'
          ? `https://www.youtube.com/embed/${extId}?autoplay=1`
          : `https://player.vimeo.com/video/${extId}?autoplay=1`;
        const existing = mainSlot.querySelector('img, video, iframe');
        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.style.cssText = 'width:100%;height:100%;border:0;display:block;';
        if (existing) existing.replaceWith(iframe);
        else mainSlot.appendChild(iframe);

      } else {
        /* ── Immagine ── */
        const newSrc    = thumb.dataset.src;
        const newSrcset = thumb.dataset.srcset;
        if (!newSrc) return;

        let mainImg = mainSlot.querySelector('img');
        if (!mainImg) {
          /* Stava mostrando video/iframe: ricrea l'img */
          const existing = mainSlot.querySelector('video, iframe');
          mainImg = document.createElement('img');
          mainImg.id = 'product-main-image';
          mainImg.loading = 'eager';
          if (existing) existing.replaceWith(mainImg);
          else mainSlot.appendChild(mainImg);
        }
        mainImg.style.opacity   = '0';
        mainImg.style.transform = 'scale(1.04)';
        setTimeout(() => {
          mainImg.src = newSrc;
          if (newSrcset) mainImg.srcset = newSrcset;
          mainImg.style.transition = 'opacity 0.5s, transform 0.7s';
          mainImg.style.opacity    = '1';
          mainImg.style.transform  = 'scale(1)';
        }, 220);
      }
    });
  });
}

/* ────────────────────────────────────────────────────────────
   FOCUS-TRAP — utility riutilizzabile per i dialog modali
──────────────────────────────────────────────────────────── */
function trapFocus(container) {
  const SEL = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
  function onKey(e) {
    if (e.key !== 'Tab') return;
    const f = Array.prototype.slice.call(container.querySelectorAll(SEL)).filter(el => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  container.addEventListener('keydown', onKey);
  return function () { container.removeEventListener('keydown', onKey); };
}

/* ────────────────────────────────────────────────────────────
   Search Modal (+ focus-trap + ricerca predittiva)
   ──────────────────────────────────────────────────────────── */
function initSearchModal() {
  const modal    = document.getElementById('search-modal');
  const overlay  = document.getElementById('search-overlay');
  const input    = document.getElementById('search-modal-input');
  const openBtns = document.querySelectorAll('[data-search-open]');
  const closeBtns = document.querySelectorAll('[data-search-close]');
  if (!modal) return;
  let lastFocusS = null, releaseTrapS = null;

  function openSearch() {
    modal.classList.add('is-open');
    overlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    lenis?.stop();
    lastFocusS = document.activeElement;
    releaseTrapS = trapFocus(modal);
    setTimeout(() => input?.focus(), 80);
  }
  function closeSearch() {
    modal.classList.remove('is-open');
    overlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
    lenis?.start();
    if (releaseTrapS) { releaseTrapS(); releaseTrapS = null; }
    if (lastFocusS && lastFocusS.focus) { lastFocusS.focus(); lastFocusS = null; }
  }

  openBtns.forEach(btn => btn.addEventListener('click', openSearch));
  closeBtns.forEach(btn => btn.addEventListener('click', closeSearch));
  overlay?.addEventListener('click', closeSearch);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeSearch(); });

  // ── Ricerca predittiva (Shopify Predictive Search API) ──
  const results = document.getElementById('search-modal-results');
  if (input && results) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const money = v => '€ ' + (v / 100).toLocaleString(document.documentElement.lang || 'it', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    let _t = null, _ctrl = null;
    input.setAttribute('autocomplete', 'off');
    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(_t);
      if (q.length < 2) { results.innerHTML = ''; results.hidden = true; return; }
      _t = setTimeout(() => {
        if (_ctrl) _ctrl.abort();
        _ctrl = new AbortController();
        const u = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,article&resources[limit]=6' +
          '&resources[options][unavailable_products]=last';
        fetch(u, { signal: _ctrl.signal })
          .then(r => r.json())
          .then(data => {
            const rr = (data.resources && data.resources.results) || {};
            let html = '';
            if (rr.products && rr.products.length) {
              html += '<ul class="search-results__list" role="list">';
              rr.products.forEach(p => {
                const img = (p.featured_image && p.featured_image.url)
                  ? '<img src="' + p.featured_image.url + '" alt="" width="48" height="48" loading="lazy">' : '';
                const price = (p.price_min != null)
                  ? '<span class="search-results__price">' + money(p.price_min) + '</span>' : '';
                html += '<li><a class="search-results__item" href="' + p.url + '">' + img +
                  '<span class="search-results__title">' + p.title + '</span>' + price + '</a></li>';
              });
              html += '</ul>';
            }
            const links = []
              .concat((rr.collections || []).map(c => ({ t: c.title, u: c.url })))
              .concat((rr.pages || []).map(pg => ({ t: pg.title, u: pg.url })))
              .concat((rr.articles || []).map(a => ({ t: a.title, u: a.url })));
            if (links.length) {
              html += '<ul class="search-results__links" role="list">';
              links.forEach(l => { html += '<li><a href="' + l.u + '">' + l.t + '</a></li>'; });
              html += '</ul>';
            }
            results.innerHTML = html || '<p class="search-results__empty">Nessun risultato — premi Invio per la ricerca completa.</p>';
            results.hidden = false;
          })
          .catch(err => { if (err.name !== 'AbortError') results.hidden = true; });
      }, 220);
    });
  }
}

function initCartDrawer() {
  const drawer   = document.querySelector('.cart-drawer');
  const overlay  = document.querySelector('.cart-overlay');
  const openBtns  = document.querySelectorAll('[data-cart-open]');
  const closeBtns = document.querySelectorAll('[data-cart-close]');
  if (!drawer) return;
  let lastFocus = null, releaseTrap = null;

  function openCart() {
    drawer.classList.add('is-open');
    overlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    lenis?.stop();
    lastFocus = document.activeElement;
    releaseTrap = trapFocus(drawer);
    const f = drawer.querySelector('[data-cart-close]');
    if (f) setTimeout(() => f.focus(), 50);
  }
  function closeCart() {
    drawer.classList.remove('is-open');
    overlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
    lenis?.start();
    if (releaseTrap) { releaseTrap(); releaseTrap = null; }
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
  }

  openBtns.forEach(btn => btn.addEventListener('click', openCart));
  closeBtns.forEach(btn => btn.addEventListener('click', closeCart));
  overlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart(); });
}

/* ────────────────────────────────────────────────────────────
   MOBILE NAV
──────────────────────────────────────────────────────────── */
function initMobileNav() {
  const toggle = document.querySelector('.menu-toggle');
  const nav    = document.querySelector('.mobile-nav');
  if (!toggle || !nav) return;

  let navRelease = null;
  toggle.addEventListener('click', () => {
    const isOpen = toggle.classList.toggle('is-open');
    nav.classList.toggle('is-open', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
    toggle.setAttribute('aria-expanded', String(isOpen));
    if (isOpen) { lenis?.stop(); navRelease = trapFocus(nav); }
    else { lenis?.start(); if (navRelease) { navRelease(); navRelease = null; } toggle.focus(); }
  });

  // Chiude su QUALSIASI link (anche i sotto-link), ripristinando scroll/focus
  nav.querySelectorAll('a[href]').forEach(link => {
    link.addEventListener('click', () => {
      toggle.classList.remove('is-open');
      nav.classList.remove('is-open');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
      if (navRelease) { navRelease(); navRelease = null; }
      lenis?.start();
    });
  });

  // Mobile submenu toggles
  nav.querySelectorAll('[data-mobile-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isExpanded));
      const children = btn.nextElementSibling;
      if (children) children.hidden = isExpanded;
    });
  });
}

/* ────────────────────────────────────────────────────────────
   PAGE TRANSITION
──────────────────────────────────────────────────────────── */
function initPageTransition() {
  if (document.body.dataset.pageTransition === 'false') return;
  const overlay = document.getElementById('page-transition');
  if (!overlay) return;
  if (prefersReducedMotion) return;

  document.querySelectorAll('a:not([target="_blank"]):not([href^="#"]):not([href^="mailto"])').forEach(link => {
    link.addEventListener('click', e => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('javascript') || e.ctrlKey || e.metaKey) return;
      e.preventDefault();
      overlay.style.transition     = 'transform 0.5s cubic-bezier(0.65, 0, 0.35, 1)';
      overlay.style.transform      = 'scaleY(1)';
      overlay.style.transformOrigin = 'bottom';
      setTimeout(() => { window.location.href = href; }, 500);
    });
  });

  window.addEventListener('pageshow', () => {
    overlay.style.transition   = 'none';
    overlay.style.transformOrigin = 'top';
    overlay.style.transform    = 'scaleY(0)';
    requestAnimationFrame(() => {
      overlay.style.transition = 'transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)';
    });
  });
}

/* ────────────────────────────────────────────────────────────
   QUICK ADD TO CART (Shopify AJAX API)
──────────────────────────────────────────────────────────── */
document.addEventListener('click', async e => {
  const btn = e.target.closest('[data-add-to-cart]');
  if (!btn) return;

  const form = btn.closest('form');
  // L'aggiunta è gestita via AJAX: se il bottone è un submit dentro un form,
  // blocca l'invio nativo (altrimenti il form fa POST a /cart e naviga via,
  // il drawer non si apre e il feedback "Aggiunto ✓" viene troncato).
  if (form) e.preventDefault();
  const variantId = btn.dataset.variantId || form?.querySelector('[name="id"]')?.value;
  if (!variantId) return;

  // Legge la quantità scelta (selettore opzionale product-quantity); fallback 1.
  const qtyField = form?.querySelector('[name="quantity"]');
  const quantity = Math.max(1, parseInt(qtyField?.value, 10) || 1);

  btn.classList.add('is-loading');
  btn.disabled = true;

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    });
    if (!res.ok) {
      let _msg = '';
      try { const _err = await res.json(); _msg = _err.description || _err.message || ''; } catch (_e) {}
      throw new Error(_msg || 'Add to cart failed');
    }

    await refreshCartDrawer();

    var _live = document.getElementById('a11y-cart-status');
    if (_live) _live.textContent = 'Prodotto aggiunto al carrello';
    btn.textContent = 'Aggiunto ✓';
    setTimeout(() => {
      btn.textContent = btn.dataset.originalText || 'Aggiungi al carrello';
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }, 2000);

    document.querySelector('[data-cart-open]')?.click();
  } catch (err) {
    console.error(err);
    btn.classList.remove('is-loading');
    btn.disabled = false;
    // Feedback utente invece del fallimento silenzioso (es. scorta insufficiente)
    const _orig = btn.dataset.originalText || btn.textContent;
    btn.textContent = (err && err.message && err.message !== 'Add to cart failed') ? err.message : 'Riprova';
    var _liveErr = document.getElementById('a11y-cart-status');
    if (_liveErr) _liveErr.textContent = btn.textContent;
    setTimeout(() => { btn.textContent = _orig; }, 2600);
  }
});

/* ────────────────────────────────────────────────────────────
   MARQUEE pause on hover
──────────────────────────────────────────────────────────── */
document.querySelectorAll('.features-bar__track').forEach(track => {
  track.parentElement?.addEventListener('mouseenter', () => {
    track.style.animationPlayState = 'paused';
  });
  track.parentElement?.addEventListener('mouseleave', () => {
    track.style.animationPlayState = 'running';
  });
});

/* ────────────────────────────────────────────────────────────
   NEWSLETTER FORM
──────────────────────────────────────────────────────────── */
/* Handler rimosso: ascoltava 'submit' su .newsletter__form, che è un <div> figlio
   del <form> e non emette mai l'evento submit (era codice morto + feedback finto).
   Il form {% form 'customer' %} invia in nativo e mostra il successo lato server
   via form.posted_successfully?. */

/* ────────────────────────────────────���─────────────────────
   CART DRAWER REFRESH  (called after every AJAX add-to-cart)
────────────────────────────────────────────────────────── */
async function refreshCartDrawer() {
  try {
    const cartRes = await fetch('/cart.js');
    const cart    = await cartRes.json();

    // badge
    const countEl = document.querySelector('.cart-count');
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.classList.toggle('is-visible', cart.item_count > 0);
      // Bump del badge per dare feedback all'aggiunta
      if (cart.item_count > 0) {
        countEl.classList.remove('is-bump');
        void countEl.offsetWidth; // forza reflow per ri-triggerare l'animazione
        countEl.classList.add('is-bump');
      }
    }

    // body
    const body = document.getElementById('cart-drawer-body');
    if (body) {
      if (cart.item_count === 0) {
        body.innerHTML = '<p style="color:var(--c-text-muted);font-size:var(--fs-sm);padding:var(--space-8) 0;">Il tuo carrello &egrave; vuoto.</p>';
      } else {
        const L = { dec: body.dataset.i18nDec || 'Diminuisci quantità', inc: body.dataset.i18nInc || 'Aumenta quantità', rem: body.dataset.i18nRem || 'Rimuovi articolo' };
        body.innerHTML = cart.items.map(item => {
          const imgSrc = item.featured_image ? item.featured_image.url : (item.image || '');
          const price  = (item.final_line_price / 100).toLocaleString('it-IT', {minimumFractionDigits:2, maximumFractionDigits:2});
          const variantLine = (item.variant_title && item.variant_title !== 'Default Title')
            ? `<p class="cart-line__variant">${item.variant_title}</p>` : '';
          return `
            <div class="cart-line" data-line-key="${item.key}">
              ${imgSrc ? `<img src="${imgSrc}" alt="" class="cart-line__img">` : ''}
              <div class="cart-line__info">
                <p class="cart-line__title">${item.product_title}</p>
                ${variantLine}
                <div class="cart-line__qty">
                  <button type="button" class="cart-qty-btn" data-qty-delta="-1" aria-label="${L.dec}">&#8722;</button>
                  <span class="cart-line__qval" aria-live="polite">${item.quantity}</span>
                  <button type="button" class="cart-qty-btn" data-qty-delta="1" aria-label="${L.inc}">&#43;</button>
                </div>
                <p class="cart-line__price">&euro; ${price}</p>
              </div>
              <button type="button" class="cart-line__remove" data-line-remove aria-label="${L.rem}">&times;</button>
            </div>`;
        }).join('');
      }
    }

    // total
    const totalEl = document.querySelector('.cart-drawer__subtotal span:last-child');
    if (totalEl && cart.total_price !== undefined) {
      const t = (cart.total_price / 100).toLocaleString('it-IT', {minimumFractionDigits:2, maximumFractionDigits:2});
      totalEl.textContent = '€ ' + t;
    }
    updateShipBar(cart.total_price);

    // Upsell: nascondi se il suo prodotto è già nel carrello (o carrello vuoto)
    const upsell = document.getElementById('cart-upsell');
    if (upsell) {
      const upVar = parseInt(upsell.dataset.upsellVariant, 10);
      const upProd = parseInt(upsell.dataset.upsellProduct, 10);
      const inCart = cart.items.some(it => it.id === upVar || it.variant_id === upVar || it.product_id === upProd);
      upsell.style.display = (inCart || cart.item_count === 0) ? 'none' : '';
    }
  } catch(err) {
    console.error('Cart refresh error:', err);
  }
}

/* ──────────────────────────────────────────────────────────
   CART DRAWER — stepper quantità (+/−) e rimozione riga (/cart/change.js)
────────────────────────────────────────────────────────── */
document.addEventListener('click', async function (e) {
  const stepBtn = e.target.closest('.cart-qty-btn');
  const remBtn  = e.target.closest('[data-line-remove]');
  if (!stepBtn && !remBtn) return;
  const line = e.target.closest('.cart-line');
  if (!line) return;
  const key = line.dataset.lineKey;
  let qty;
  if (remBtn) {
    qty = 0;
  } else {
    const cur = parseInt(line.querySelector('.cart-line__qval').textContent, 10) || 1;
    qty = Math.max(0, cur + parseInt(stepBtn.dataset.qtyDelta, 10));
  }
  const btns = line.querySelectorAll('button');
  btns.forEach(b => b.disabled = true);
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    if (!res.ok) throw new Error('change failed');
    await refreshCartDrawer();
  } catch (err) {
    console.error(err);
    btns.forEach(b => b.disabled = false);
  }
});

/* ──────────────────────────────────────────────────────────
   VARIANT PICKER  — price / image / URL / availability
────────────────────────────────────────────────────────── */
function initVariantPicker() {
  const form  = document.getElementById('product-form');
  if (!form) return;
  const varEl = document.getElementById('product-variants-json');
  if (!varEl) return;
  let variants;
  try { variants = JSON.parse(varEl.textContent); } catch(e) { return; }
  if (!variants || !variants.length) return;

  const idInput = form.querySelector('input[name="id"]');

  function getSelected() {
    const sel = [];
    form.querySelectorAll('.variant-option').forEach(grp => {
      const checked = grp.querySelector('input[type="radio"]:checked');
      if (checked) sel.push(checked.value);
    });
    return sel;
  }

  function findVariant(selected) {
    return variants.find(v => {
      const ops = [v.option1, v.option2, v.option3].filter(x => x !== null && x !== undefined);
      return selected.every((s, i) => ops[i] === s);
    });
  }

  function applyVariant(v) {
    if (!v) return;

    if (idInput) idInput.value = v.id;

    // URL
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    } catch(e) {}

    // Price
    const priceEl = document.querySelector('.product-info__price');
    if (priceEl && v.price !== undefined) {
      const p = (v.price / 100).toLocaleString('it-IT', {minimumFractionDigits:2, maximumFractionDigits:2});
      priceEl.textContent = '€ ' + p;
      priceEl.setAttribute('content', (v.price / 100).toFixed(2));
    }
    const cmpEl = document.querySelector('.product-info__price-compare s, .product-info__price-compare');
    if (cmpEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        const cp = (v.compare_at_price / 100).toLocaleString('it-IT', {minimumFractionDigits:2, maximumFractionDigits:2});
        cmpEl.style.display = '';
        cmpEl.textContent = '€ ' + cp;
      } else {
        cmpEl.style.display = 'none';
      }
    }

    // Sticky price
    const stickyPrice = document.querySelector('.sticky-atc__price');
    if (stickyPrice && v.price !== undefined) {
      const p = (v.price / 100).toLocaleString('it-IT', {minimumFractionDigits:2, maximumFractionDigits:2});
      stickyPrice.textContent = '€ ' + p;
    }

    // Image
    if (v.featured_image) {
      const mainImg = document.getElementById('product-main-image');
      if (mainImg) { mainImg.src = v.featured_image; mainImg.srcset = ''; }
    }

    // Stock urgency
    updateStockUrgency(v.inventory_quantity || 0, v.inventory_management || null);

    // Availability
    const actions = form.querySelector('.product-form__actions');
    if (actions) {
      const addBtn = actions.querySelector('[data-add-to-cart]');
      const disBtn = actions.querySelector('.product-form__submit[disabled]');
      if (v.available) {
        if (disBtn && !addBtn) {
          disBtn.remove();
          const btn = document.createElement('button');
          btn.type = 'submit';
          btn.className = 'btn btn--gold product-form__submit';
          btn.setAttribute('data-add-to-cart', '');
          const orig = form.dataset.origBtnText || 'Aggiungi al carrello';
          btn.setAttribute('data-original-text', orig);
          btn.textContent = orig;
          actions.insertBefore(btn, actions.firstChild);
        }
        if (addBtn) addBtn.disabled = false;
      } else {
        if (addBtn && !disBtn) {
          if (!form.dataset.origBtnText) {
            form.dataset.origBtnText = addBtn.getAttribute('data-original-text') || addBtn.textContent.trim();
          }
          addBtn.remove();
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'btn btn--outline product-form__submit';
          btn.disabled = true;
          btn.textContent = 'Esaurito';
          actions.insertBefore(btn, actions.firstChild);
        }
      }
    }
  }

  // Marca i valori-opzione non disponibili (barrati), considerando le opzioni già scelte
  function updateAvailabilityStates() {
    const selected = getSelected();
    form.querySelectorAll('.variant-option').forEach((grp, gi) => {
      grp.querySelectorAll('input[type="radio"]').forEach(radio => {
        const lbl  = radio.closest('label');
        const span = lbl ? lbl.querySelector('.variant-btn') : radio.nextElementSibling;
        if (!span) return;
        const candidate = selected.slice();
        candidate[gi] = radio.value;
        const hasAvail = variants.some(v => {
          const ops = [v.option1, v.option2, v.option3];
          for (let i = 0; i <= gi; i++) {
            if (candidate[i] !== undefined && ops[i] !== candidate[i]) return false;
          }
          return v.available;
        });
        span.classList.toggle('is-unavailable', !hasAvail);
        if (!hasAvail) { span.setAttribute('title', 'Esaurito'); }
        else { span.removeAttribute('title'); }
      });
    });
  }

  // click on visible span → triggers underlying radio
  form.addEventListener('click', function(e) {
    const span = e.target.closest('.variant-btn');
    if (!span) return;
    const lbl   = span.closest('label');
    const radio = lbl ? lbl.querySelector('input[type="radio"]') : span.previousElementSibling;
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // radio change
  form.addEventListener('change', function(e) {
    if (e.target.type !== 'radio') return;
    const name = e.target.name;
    form.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach(r => {
      const lbl  = r.closest('label');
      const span = lbl ? lbl.querySelector('.variant-btn') : r.nextElementSibling;
      if (span) span.classList.toggle('is-active', r.checked);
    });
    const variant = findVariant(getSelected());
    if (variant) applyVariant(variant);
    updateAvailabilityStates();
  });

  // Stato iniziale: barra subito i formati esauriti
  updateAvailabilityStates();
}

/* ━━━ Free Shipping Bar ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */
function updateShipBar(cartTotal) {
  const bar = document.getElementById('cart-ship-bar');
  if (!bar) return;
  const threshold = parseInt(bar.dataset.threshold, 10);
  if (!threshold) return;
  const fill = document.getElementById('cart-ship-bar-fill');
  const text = document.getElementById('cart-ship-bar-text');
  const pct  = Math.min(100, Math.round((cartTotal / threshold) * 100));
  const rem  = Math.max(0, threshold - cartTotal);
  if (fill) fill.style.width = pct + '%';
  if (text) {
    if (rem <= 0) {
      text.textContent = '\u2713 Spedizione gratuita applicata!';
      text.classList.add('is-reached');
    } else {
      const remFmt = (rem / 100).toLocaleString('it-IT', {minimumFractionDigits:2});
      text.textContent = 'Aggiungi \u20ac' + remFmt + ' per la spedizione gratuita';
      text.classList.remove('is-reached');
    }
  }
}

/* ━━━ Stock Urgency ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */
function updateStockUrgency(qty, management) {
  const el = document.getElementById('product-stock-urgency');
  if (!el) return;
  if (management && qty > 0 && qty <= 10) {
    const unit = qty === 1 ? 'pezzo disponibile' : 'pezzi disponibili';
    el.childNodes[el.childNodes.length - 1].textContent = '\nSolo ' + qty + ' ' + unit + '\n          ';
    el.style.display = 'flex';
  } else {
    el.style.display = 'none';
  }
}

/* -=- Recently Viewed -=- */
function initRecentlyViewed() {
  var dataEl = document.getElementById('product-current-json');
  if (!dataEl) return;
  var current;
  try { current = JSON.parse(dataEl.textContent); } catch(e) { return; }
  var KEY = 'bh_recently_viewed';
  var viewed = [];
  try { viewed = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e) {}
  viewed = viewed.filter(function(p){ return p.id !== current.id; });
  viewed.unshift(current);
  viewed = viewed.slice(0, 8);
  try { localStorage.setItem(KEY, JSON.stringify(viewed)); } catch(e) {}
  var others = viewed.filter(function(p){ return p.id !== current.id; }).slice(0, 4);
  if (others.length === 0) return;
  var section = document.getElementById('product-recently');
  var grid    = document.getElementById('recently-grid');
  if (!section || !grid) return;
  grid.innerHTML = others.map(function(p) {
    var price = (p.price / 100).toLocaleString('it-IT', { minimumFractionDigits: 2 });
    var title = p.title.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return '<a href="' + p.url + '" class="recently-card">' +
      '<img src="' + p.image + '" alt="' + title + '" class="recently-card__img" loading="lazy">' +
      '<p class="recently-card__title">' + title + '</p>' +
      '<p class="recently-card__price">' + price + ' €</p>' +
      '</a>';
  }).join('');
  section.style.display = '';
}

/* ━━━ Back-in-Stock Form ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */
document.addEventListener('submit', function(e) {
  const form = e.target.closest('.back-in-stock');
  if (!form) return;
  e.preventDefault();
  const email = form.querySelector('input[type="email"]');
  if (!email || !email.value) return;
  const data = new FormData(form);
  fetch(form.action, { method: 'POST', body: data })
    .then(() => {
      form.querySelector('.back-in-stock__row').style.display = 'none';
      form.querySelector('.back-in-stock__note').style.display = 'none';
      const ok = form.querySelector('.back-in-stock__success');
      if (ok) ok.style.display = 'block';
    })
    .catch(() => {
      alert('Errore di rete. Riprova.');
    });
});

/* ━━━ Cart Upsell ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */
document.addEventListener('click', function(e) {
  const btn = e.target.closest('[data-upsell-id]');
  if (!btn) return;
  const variantId = parseInt(btn.dataset.upsellId, 10);
  if (!variantId) return;
  btn.disabled = true;
  btn.textContent = '...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
  .then(r => r.json())
  .then(() => {
    btn.textContent = '\u2713';
    btn.style.background = '#4CAF50';
    if (typeof refreshCartDrawer === 'function') refreshCartDrawer();
  })
  .catch(() => {
    btn.textContent = '+';
    btn.disabled = false;
  });
});


/* Language Switcher */
(function() {
  var btn = document.getElementById('lang-switcher-btn');
  var dropdown = document.getElementById('lang-switcher-dropdown');
  if (!btn || !dropdown) return;
  btn.addEventListener('click', function(e) {
    e.stopPropagation();
    var open = dropdown.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.addEventListener('click', function() {
    dropdown.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      dropdown.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
  });
})();
